// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__UWy0Z","sendOtp":"AuthorizeToLogin_sendOtp__Ao0ws"};